import React from 'react';

import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle, } from 'components/molecules';
import { News } from 'components/organisms';
/** styles **/
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';

/** styles **/
import s from '../styles/pages/news-list.module.scss';

export const NewsList: React.FC = () => {
  return (
    <Layout>
      <div className={s.newsListPageWrapper}>
        <ContentsTitle className={s.contentsTitle} title="お知らせ" subTitle={`P-manからのお知らせや\nペットフレンドリー物件情報`} />
        <div className={s.newsListWrapper}>
          <News />
        </div>

        <Link className={s.topLink} to="/">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
